import Editar from "./Editar";

const paginas = { Editar };
export default paginas